import React, { useMemo } from 'react';
import { SlatSilhouetteSvg } from './SlatSilhouetteSvg';
import { useSlatMorphBetweenImages } from './useSlatMorphBetweenImages';

/**
 * Composes morph hook + silhouette for embeds and slides.
 *
 * @param {object} props
 * @param {string} props.srcA
 * @param {string} props.srcB
 * @param {boolean} [props.active]
 * @param {number} [props.viewBoxSize=200]
 * @param {boolean} [props.dropShadow]
 * @param {object} [props.morphOptions] - rowCount, morphRowCountFrom/To, morphMidRowCount, twoPhaseMorph, analyticCircleSlats, durationMs, smoothing, etc.
 * @param {object} [props.svgAttrs]
 */
export function SlatMorphSvg({
  srcA,
  srcB,
  active = false,
  viewBoxSize = 200,
  dropShadow = true,
  morphOptions = {},
  svgAttrs = {},
}) {
  const viewBox = useMemo(
    () => ({ width: viewBoxSize, height: viewBoxSize }),
    [viewBoxSize],
  );
  const { rects } = useSlatMorphBetweenImages(srcA, srcB, {
    ...morphOptions,
    active,
    viewBox,
  });

  return (
    <SlatSilhouetteSvg
      rects={rects}
      viewBoxSize={viewBoxSize}
      dropShadow={dropShadow}
      svgAttrs={{ 'aria-hidden': true, ...svgAttrs }}
    />
  );
}
